import PropTypes from 'prop-types'
import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import MaterialTable from '@material-table/core'
import { Switch } from '@mui/material'

import {
  adjustInventory,
  markDoNotSell,
  setQuantity,
} from '../../../services/todays-inventory-service'
import { getProductsStoresForStore } from '@store/selectors/products-stores'
import { setFlashMessage } from '@store/reducers/flash-message/actions'

const mapStateToProps = (state, ownProps) => ({
  inventory: Object.values(getProductsStoresForStore(state, ownProps.storeId))
    .map((productStore) => {
      const product = state.Products[productStore.product_id]
      return product.variants.map((variant) => ({
        inventory:
          (state.TodaysInventory[ownProps.storeId] || {})[variant.id] || {},
        product,
        variant,
      }))
    })
    .flat()
    .filter((x) => x.product.inventory_control != 'unlimited'),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  actions: {
    incrementInventory: (variantId) =>
      adjustInventory(dispatch)(ownProps.storeId, variantId, 1),
    decrementInventory: (variantId) =>
      adjustInventory(dispatch)(ownProps.storeId, variantId, -1),
    markDoNotSell: (variantId, doNotSell) =>
      markDoNotSell(dispatch)(ownProps.storeId, variantId, doNotSell),
    setInventoryQuantity: (variantId, quantity) =>
      setQuantity(dispatch)(ownProps.storeId, variantId, quantity),
    ...bindActionCreators(
      {
        setFlashMessage,
      },
      dispatch,
    ),
  },
})

function TodaysInventoryWidget(props) {
  const { actions, editable, className } = props
  return (
    <div className={className}>
      <MaterialTable
        actions={
          editable
            ? [
                {
                  icon: 'remove',
                  tooltip: 'Decrement',
                  onClick: (_, rowData) => {
                    actions.decrementInventory(rowData.variant.id)
                  },
                },
                {
                  icon: 'add',
                  tooltip: 'Increment',
                  onClick: (_, rowData) => {
                    actions.incrementInventory(rowData.variant.id)
                  },
                },
              ]
            : []
        }
        columns={[
          {
            title: 'Product',
            editable: 'never',
            field: 'product.name',
            render: (rowData) =>
              `${rowData.product.name} (${rowData.variant.sku})`,
          },
          {
            title: 'Inventory',
            field: 'inventory.quantity_available',
            emptyValue: <em>Not Set</em>,
          },
          {
            title: 'Available',
            field: 'inventory.do_not_sell',
            editable: 'never',
            render: (rowData) => {
              const inventory = rowData.inventory || {}

              return editable ? (
                <Switch
                  checked={!(inventory.do_not_sell === true)}
                  onChange={(event) => {
                    actions.markDoNotSell(
                      rowData.variant.id,
                      !event.target.checked,
                    )
                  }}
                />
              ) : (
                <span>{inventory.do_not_sell ? 'No' : 'Yes'}</span>
              )
            },
          },
        ]}
        data={props.inventory}
        editable={
          editable && {
            onRowUpdate: async (newData) => {
              return actions.setInventoryQuantity(
                newData.variant.id,
                newData.inventory.quantity_available,
              )
            },
          }
        }
        options={{
          actionsColumnIndex: 3,
        }}
        title={"Today's Inventory"}
      />
    </div>
  )
}

TodaysInventoryWidget.propTypes = {
  storeId: PropTypes.number,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TodaysInventoryWidget)
